import DownloadT4A from '../components/DownloadT4A'

function T4ADownload() {
  return (
    <div>
      <img
        src='/images/group-copy.svg'
        alt=''
        style={{
          height: 42,
          width: 178,
          marginTop: 22,
          marginLeft: 20
        }}
      />
      <DownloadT4A />
    </div>
  )
}

export default T4ADownload
